var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { shapes, util } from '@joint/plus';
var color = '#F93943';
var Dependency = /** @class */ (function (_super) {
    __extends(Dependency, _super);
    function Dependency() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dependency.prototype.defaults = function () {
        return util.defaultsDeep({
            z: 3,
            type: 'kanban.Dependency',
            attrs: util.defaultsDeep({
                line: {
                    stroke: color,
                    strokeDasharray: '5,5',
                    targetMarker: {
                        d: 'M 0 0 7 5 7 -5'
                    }
                }
            }),
            labels: [{
                    position: 0.3,
                    attrs: {
                        text: {
                            fontSize: 8,
                            fontFamily: 'sans-serif',
                            text: 'depends on',
                            fill: 'white'
                        },
                        rect: {
                            fill: color,
                            stroke: color,
                            strokeWidth: 5,
                            rx: 1,
                            ry: 1
                        }
                    }
                }]
        }, _super.prototype.defaults);
    };
    return Dependency;
}(shapes.standard.Link));
export { Dependency };
